import React from 'react';
import { Link } from 'react-router-dom';

function MainFooter() {
  return (
    <footer className="bg-[#102A43] text-[#94A3B8]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          {/* Standards */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Standards</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/standards" className="hover:text-white transition-colors">Standards Index</Link></li>
              <li><Link to="/framework-alignment" className="hover:text-white transition-colors">Framework Alignment</Link></li>
              <li><Link to="/why-these-standards-exist" className="hover:text-white transition-colors">Why These Standards Exist</Link></li>
              <li><Link to="/archived-standards" className="hover:text-white transition-colors">Archived Standards</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/articles" className="hover:text-white transition-colors">Articles & Guides</Link></li>
              <li><Link to="/free-tools" className="hover:text-white transition-colors">Free Tools</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About AASC</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Products</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/assessment/form" className="hover:text-white transition-colors">AI Accountability Score (free)</Link></li>
              <li><Link to="/documentation-system" className="hover:text-white transition-colors">Documentation System ($97)</Link></li>
              <li><Link to="/assessment-product" className="hover:text-white transition-colors">Assessment ($297)</Link></li>
              <li><Link to="/apply" className="hover:text-white transition-colors">Accountability Declaration ($997/yr)</Link></li>
            </ul>
          </div>

          {/* Registry */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Registry</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/registry" className="hover:text-white transition-colors">Public Registry</Link></li>
              <li><Link to="/verify-credential" className="hover:text-white transition-colors">Verify Declaration Status</Link></li>
              <li><Link to="/registry-status-definitions" className="hover:text-white transition-colors">Registry Status Definitions</Link></li>
              <li><Link to="/submit-a-concern" className="hover:text-white transition-colors">Submit a Concern</Link></li>
            </ul>
          </div>

          {/* Governance */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Governance</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/governance-and-authority" className="hover:text-white transition-colors">Governance & Authority</Link></li>
              <li><Link to="/independence-statement" className="hover:text-white transition-colors">Independence Statement</Link></li>
              <li><Link to="/scope-of-applicability" className="hover:text-white transition-colors">Scope of Applicability</Link></li>
              <li><Link to="/programs-and-pricing" className="hover:text-white transition-colors">Programs & Pricing</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wide mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/terms-of-declaration" className="hover:text-white transition-colors">Terms of Declaration</Link></li>
              <li><Link to="/declaration-badge-usage-policy" className="hover:text-white transition-colors">Declaration Badge Usage</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1e3a5f] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-center md:text-left">
              &copy; {new Date().getFullYear()} AI Accountability Standards Council. All rights reserved.
            </p>
            <p className="text-xs text-center md:text-right max-w-xl">
              AASC is not a law firm and does not provide legal advice. AASC is the operational framework organizations use to prepare for AI governance expectations.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default MainFooter;
